// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../images/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../images/cover_image.a08b3550.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Exo:wght@800&family=Montserrat:wght@300&family=Open+Sans+Condensed:wght@700&family=Roboto+Slab:wght@700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-size: 100%;
}

body {
  margin: 0;
  /* font-family: Open Sans Condensed, sans-serif; */
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
}

.font_11 {
  font-size: 0.688rem;
}

.font_12 {
  font-size: 0.75rem;
}

.font_13 {
  font-size: 0.813rem;
}

.font_14 {
  font-size: 0.875rem;
}

.font_15 {
  font-size: 0.938rem;
}

.font_16 {
  font-size: 14px;
}
.font_17 {
  font-size: 16px;
}

.font_18 {
  font-size: 1.125rem;
}

.font_19 {
  font-size: 1.188rem;
}

.font_20 {
  font-size: 1.25rem;
}

.font_22 {
  font-size: 1.375rem;
}

.font_24 {
  font-size: 1.5rem;
}

.font_26 {
  font-size: 1.625rem;
}

.font_28 {
  font-size: 1.75rem;
}

.font_30 {
  font-size: 1.875rem;
}

.font_32 {
  font-size: 2rem;
}

.font_34 {
  font-size: 2.125rem;
}

.font_36 {
  font-size: 2.25rem;
}

.font_38 {
  font-size: 2.375rem;
}

.font_40 {
  font-size: 2.5rem;
}

.font_42 {
  font-size: 2.625rem;
}

.font_44 {
  font-size: 2.75rem;
}

.font_46 {
  font-size: 2.875rem;
}

.font_48 {
  font-size: 3rem;
}

.font_50 {
  font-size: 3.125rem;
}

.font_52 {
  font-size: 3.25rem;
}

.font_54 {
  font-size: 3.375rem;
}

.font_600 {
  font-weight: 600;
}

.font_700 {
  font-weight: 700;
}

.font_r {
  color: red;
}

.font_y {
  color: #ffe972;
}

.font_blk {
  color: #000;
}

.font_w {
  color: #fff;
}

.font_gry {
  color: gray;
}

.font_mgnt {
  color: #8b008b;
}

.font_bl {
  color: #003153;
}

.letter_15 {
  letter-spacing: 0.15em;
}

.alanlabel {
  font-size: 3.25rem;
  font-weight: 600;
  flex: 1 1;
  text-align: center;
  cursor: pointer;
  letter-spacing: 0.15em;
  font-family: Open Sans Condensed, sans-serif;
  margin: -1rem 0 0.1rem 7rem;
}

.alanlabel:hover {
  color: #ffe972;
}

.border-top {
  border-top: 0.375rem solid #ffe972;
}

.universalbackground {
  background: linear-gradient(#3e205a, #212020);
}
/* 
.universalbackground4 {
  background: linear-gradient(c281e3,);
} */

.universalbackground2 {
  background: linear-gradient(#3e205a, #000);
}

.universalbackground3 {
  background: linear-gradient(
    #3e205a 6.25rem,
    #324a80 75rem,
    #000 131.25rem,
    #3e205a 187.5rem,
    #000 243.75rem
  );
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  color: #fff;
  background: #000;
  z-index: 111;
}

.nav1 {
  height: 6.25rem;
  display: flex;
  padding: 0.5em 1em;
  justify-content: space-between;
  align-items: center;
}

.navcontainer {
  padding: 0 0em 1rem;
  display: flex;
  justify-content: space-evenly;
  font-weight: 700;
  position: relative;
  max-width: 87.5rem;
  margin: 0 auto;
  width: 100%;
  margin-left: 3rem;
  cursor: pointer;
  z-index: 44;
}

.navcontainer div:hover {
  color: #ffe972;
}

.navbar li {
  cursor: pointer;
  font-size: 1.063rem;
  font-weight: 700;
}

.navbar li:hover {
  color: #ffe972;
}

.consultbtn {
  background-color: #ffe972;
  color: #000;
  padding: 0.313rem 1.25rem;
  box-shadow: -0.625rem 0.625rem 5.625rem #ffe972;
  border: none;
  height: 2.5rem;
}

.btn {
  border: none;
  cursor: pointer;
}

#btn {
  /* animation: btn 0.5s ease-in infinite; */
  animation: btn 0.6s linear infinite;
}
.blogContents ul li::marker {
  color: #ffe972; /* Change to your desired color */
}

@keyframes btn {
  25% {
    transform: scale(0.9);
  }

  75% {
    transform: scale(1.1);
  }
}

.btn2 {
  padding: 0.313rem 1.25rem;
  color: #ffe972;
  border: none;
  cursor: pointer;
}

#btn2 {
  animation: btn2 0.5s ease-in infinite;
}

@keyframes btn2 {
  25% {
    transform: scale(0.9);
  }

  75% {
    transform: scale(1.1);
  }
}

.footerbody {
  background-color: #000;
  color: white;
}

.footerbody hr {
  border-bottom: 0.063rem solid #ffe972;
  max-width: 12.5rem;
  margin: 0.813rem auto;
  width: 100%;
}

.footerbody a {
  color: white;
  cursor: pointer;
  margin: 0px 0.5rem 0px 0.5rem;
}

footer img {
  width: 100%;
}

.banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  height: 100vh;
  display: flex;
  justify-content: center;
  background-position: no-repeat;
  background-position: 50%;
  margin-top: 9rem;
}

.successbanner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  height: 100vh;
  display: flex;
  justify-content: center;
  background-position: no-repeat;
  background-position: 50%;
  margin-top: 9rem;
  border-bottom: 6px solid rgb(255, 233, 114);
}

.whatsappcontainer {
  position: fixed;
  bottom: 0;
  right: 1.875rem;
  z-index: 999;
  padding: 0;
  font-size: 5rem;
  cursor: pointer;
  display: flex;
}

.whatsappcontainer img {
  width: 4.2rem;
  height: 4.2rem;
}

.whatsappcontainer label {
  background-color: gray;
  font-weight: 700;
  padding: 0.375rem 1.563rem;
  border-radius: 0.5rem;
  margin: 3.438rem 1.125rem auto auto;
  width: 9rem;
  position: relative;
  font-size: 1rem;
  color: white;
}

.whatsappcontainer span {
  background-color: red;
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.875rem;
  padding: 0.5rem;
  margin: 2rem 0rem 0rem -1.5rem;
}

.contactcontainer {
  background-color: transparent;
  width: 37rem;
}

.text-content {
  border: 0.063rem solid #fff;
  margin: 0.375rem 0;
  background: transparent;
  color: #717171;
  resize: none;
}

.country_codes {
  position: absolute;
  background-color: #fff;
  width: 21rem;
  height: 16rem;

  padding: 0.3rem;
  margin: 18rem 0rem 0 17.5rem;
}

.recommedation {
  width: 20rem;
  height: 16rem;
  overflow: hidden;
  overflow-y: auto;
}

.aboutalan {
  padding: 0.625rem 2.5rem 2.5rem;
  background: rgba(0, 0, 0, 0.5);
  margin-top: 6.25rem;
  border: 0.125rem solid #000;
  width: 70%;
}

.aboutalan .AlanProfileContent {
  position: relative;
}

.aboutalan .AlanProfileContent img {
  border-radius: 50%;
  border: 0.125rem solid #ffe972;
  width: 80%;
}

.sliderdiv {
  width: 100%;
  padding: 1rem;
  padding-top: 1.25rem;
  position: relative;
  perspective: 62.5rem;
  transform-style: preserve-3d;
}

.cards {
  margin: auto;
  width: 37%;
  border-radius: 16px;
  position: absolute;
  left: 0;
  right: 0;
  cursor: pointer;
  transition: transform 0.4s ease;
  background-color: #fff;
  --tw-shadow: 0 14px 40px -10px rgba(0, 0, 0, 0.35) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.cards .cardimage {
  height: 215px;
}

.cards .cardimage img {
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.cards .cardbody {
  height: 250px;
  padding: 40px 32px 20px;
}

.cards .cardbody label {
  line-height: 1.7rem;
}

.cards .cardbody p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  color: #777;
  line-height: 1.35em;
}

.slide0 {
  transform: translate3d(-60%, 0, -200px);
}

.slide1 {
  transform: translate3d(-30%, 0, -100px);
}

.slide2 {
  transform: translateZ(0);
}

.slide3 {
  transform: translate3d(30%, 0, -100px);
}

.slide4 {
  transform: translate3d(60%, 0, -200px);
}

.sidebar {
  position: fixed;
  max-width: 23.75rem;
  width: 100%;
  height: 100vh;
  background-color: #111;
  margin: 0;
  top: 0;
  color: white;
  font-size: 0.875rem;
  transition: 0.5s;
  z-index: 222;
  overflow: auto;
  overflow-x: hidden;
}

.sidebar .search {
  border-radius: 2rem;
  width: 88%;
  height: 2.5rem;
  margin-bottom: 2rem;
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center; */
}

.sidebar .search input {
  width: 16rem;
  height: 3rem;
  background-color: transparent;
  border: none;
}

.sidebar .search input:focus {
  outline: none;
}

.suggestions {
  list-style: none;
  padding: 0;
  margin: 0;
}

.suggestions li {
  padding: 0.5rem;
  cursor: pointer;
  z-index: 999;
  background-color: #deddd7; /* Adjust the background color as needed */
}

.suggestions li:hover {
  background-color: #282954; /* Adjust the hover background color as needed */
}
.suggestion-box {
  margin: 97% 15% 0 0;
  height: auto;
  width: auto;
}

.sidebar a {
  color: white;
  margin: 0.5rem;
}

.sidebar li {
  cursor: pointer;
  font-family: "Exo 2", sans-serif;
  font-size: 12px;
}

.blognav {
  background-color: #000;
  color: #fff;
  font-size: 0.875rem;
  min-width: 70rem;
}

.blognav label {
  background-color: #ffe972;
  color: #000;
  padding: 1rem;
  margin: 0;
}

.blognav li {
  list-style: none;
  margin: 0 auto;
  padding: 0rem 1rem 0 1rem;
  font-size: 11px;
  cursor: pointer;
}

.service img {
  margin-top: 9rem;
  width: 100vw;
  height: 14rem;
}

.servicecards {
  position: relative;
  height: 22rem;
  width: 22rem;
}

.servicecards img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  position: absolute;
  opacity: 1;
  transform: scale(1);
  transition: all 0.8s, opacity 0.4s;
}

.social {
  position: sticky;
  top: 14rem;
}

.socialicons {
  background-color: #000;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes servicecards {
  from {
    transform: scale(1.1);
  }

  to {
    transform: scale(1);
  }
}

.contentbody {
  background: hsla(0, 0%, 100%, 0.8);
  width: 22rem;
  height: 12rem;
  transition: all 0.5s;
  position: absolute;
  margin: auto;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0rem 0.5rem 0 0.5rem;
}

.contentbody label {
  background: linear-gradient(270deg, #433074 0, #a364a2);
  color: #fff;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  display: block;
  border-radius: 1.875rem;
  padding: 0.75rem 1.563rem 0.625rem;
  transition: all 0.5s ease;
  cursor: pointer;
  margin-bottom: 0.625rem;
}

.blogbanner {
  color: #fff;
  position: relative;
}

.blogbanner img {
  width: 100%;
}

.cover {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  /* position: relative; */
  /* align-items: center; */
  /* display: flex; */
  /* justify-content: center; */
  position: absolute;
  top: 0;
}

.cover button {
  background-color: #000;
  color: white;
  cursor: pointer;
  font-weight: 600;
  width: 10rem;
  height: 3.5rem;
  border-radius: 0.375rem;
  font-size: larger;
  margin-top: 5%;
  border: none;
}

.blogcards img {
  width: 100%;
}

.home_heading_img {
  width: 62.5rem;
}

.home_heading_body {
  width: 43.75rem;
}

.line {
  border-top: 0.063rem solid #003153;
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.imglogo {
  height: 10rem;
  aspect-ratio: 7 / 5;
  object-fit: contain;
}

.bottomUpbtn {
  position: absolute;
  right: 0px;
  margin: 0 5rem 9rem 0rem;
  font-size: 2.5rem;
  color: #ffe972;
  animation: bottomUpbtn 2s ease-in-out;
}

@keyframes bottomUpbtn {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

.successcontainer {
  padding-left: 6.25rem;
  padding-right: 0.313rem;
}

.contentimg {
  width: 100%;
}

.blogcontainer {
  margin: 10rem 5% 0 5%;
  width: 90%;
}

.blogcontainer2 {
  margin: 1rem 2% 0 2%;
  width: 100%;
}

.blognavbar {
  background-color: #000;
  color: white;
}

.blognavbar label {
  background-color: #ffe972;
  color: #000;
  padding: 1rem;
  margin: 0;
}

.blognavbar li {
  list-style: none;
  margin: 0 auto;
  padding: 0rem 1rem 0 1rem;
  cursor: pointer;
}

.acitive {
  color: #ffe972;
  font-weight: 700;
}

.servicecontainer {
  /* margin:3rem 5rem 0 5rem; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* flex-wrap: wrap; */
  /* padding-right: 4%;
    padding-left: 4%; */
  /* margin-right: 8%;
  margin-left: 8%; */
  width: 100%;
}

.servicecontainer h2 {
  font-size: 2.5rem;
  font-weight: 700;
  font-family: Roboto Slab, serif;
}

.servicecontainer hr {
  border-bottom: 3px solid #ffe972;
  max-width: 200px;
  margin: 20px auto 2.5rem;
}

.hrline {
  border-bottom: 2px solid #ffe972;
}

.plan {
  background-color: #000;
  color: #fff;
  text-align: center;
  font-family: Roboto Slab, serif;
  padding: 4rem 0rem 3rem 0rem;
}

.plan li {
  list-style: none;
  border-bottom: 1px solid rgba(9, 9, 9, 0.04);
  font-size: 12px;
  font-weight: 400;
  padding: 10px 15px;
}

.plan .month {
  font-size: 22px;
  height: 82px;
  padding: 0 8px;
  font-weight: 600;
  color: #ffe972;
}

.plan button {
  color: #000 !important;
  background-color: #ffe972 !important;
  border: none;
  border-radius: 0;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  font-family: Roboto Slab, Sans-serif;
  font-size: 15px;
  font-weight: 600;
  margin: 15px 0 10px;
  padding: 12px 25px;
}

.plan-white {
  background-color: #fff;
  color: #000;
  text-align: center;
  font-family: Roboto Slab, serif;
  padding: 4rem 0rem 3rem 0rem;
  width: 376px;
}

.plan-white li {
  list-style: none;
  border-bottom: 1px solid rgba(9, 9, 9, 0.04);
  font-size: 12px;
  font-weight: 400;
  padding: 10px 15px;
}

.plan-white .month {
  height: 82px;
  padding: 0 8px;
  font-weight: 600;
  color: #ffe972;
}

.plan-white button {
  color: #fff !important;
  background-color: #000 !important;
  border: none;
  border-radius: 0;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  font-family: Roboto Slab, Sans-serif;
  font-size: 15px;
  font-weight: 600;
  margin: 15px 0 10px;
  padding: 12px 25px;
}

/* popups */

.headermodel {
  border-bottom: 1px solid #dee2e6;
  width: 100%;
  padding: 1rem;
  justify-content: space-between;
}

.headermodel button {
  background-color: #000;
  color: #fff;
}

.Layout_inputData {
  height: 30px;
  width: 100%;
  position: relative;
}

.Layout_inputData input {
  height: 100%;
  width: 100%;
  font-size: 13px;
  border: none;
  border-bottom: 2px solid #eee;
}

.Layout_inputData input:focus {
  outline: none;
}

.Layout_inputData .Layout_underline {
  position: absolute;
  height: 2px;
  width: 100%;
  bottom: 0;
}

.Layout_inputData .Layout_underline::before {
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  background: #000;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.Layout_inputData input:focus ~ label,
.Layout_inputData input:valid ~ label {
  transform: translateY(-20px);
  font-size: 13px;
  color: #000;
}

.Layout_inputData label {
  position: absolute;
  bottom: 0;
  left: 0;
  color: #000;
  pointer-events: none;
  transition: all 0.3s ease;
  margin-bottom: 9px;
}

.copon {
  border: 1px solid #eee;
}

.couponbtn {
  background-color: #000;
  color: #fff;
  border-radius: 0.5rem;
  border: none;
}

.couponbtn:hover {
  background-color: white;
  color: black;
  border-radius: 0.5rem;
  border: 1px solid black;
}

.paybtn {
  background-color: #ffe972;
  cursor: pointer;
  border: none;
}

.footermodel {
  border-bottom: 1px solid #dee2e6;
  width: 100%;
  padding: 1rem;
  justify-content: space-between;
}

.footermodel button {
  background-color: #000;
  color: #fff;
  border-radius: 0.5rem;
  border: none;
}

.contectdetails {
  padding: 12rem 0px 5rem 0rem;
}

.brandcontainer .image {
  height: 105px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.brandcontainer .image img {
  max-height: 85px;
  margin: auto;
  width: 100%;
}

.collapsbtn {
  border: none;
}

.collapsbtn:focus {
  border: none;
  outline: none;
}

.icon {
  transform: rotate(0deg);
  transition: 0.3s ease-in-out;
}

.icon:hover {
  transform: rotate(180deg);
  transition: 0.3s ease-in-out;
}

.titlefont {
  font-size: 52px;
}

.titlefont2 {
  font-size: 30px;
}

.titlefont3 {
  font-size: 32px;
}

.titlefont4 {
  font-size: 2.5rem;
}

.titlefamily {
  font-family: Roboto Slab, serif;
}

.portfolio {
  width: 98%;
}

.phonenumber input {
  border: none;
  color: #717171;
}

.phonenumber input:focus {
  outline: none;
}

.autherimage img {
  width: 28%;
}

.authorimagebox img {
  border-radius: 50%;
  max-width: 15rem;
  height: 15rem;
}

.aboutcontainer {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.partnerrow {
  background-color: #eee;
}

.partnerrow img {
  width: 60%;
  position: relative;
}

.partnerrow .nametext {
  font-size: 1.8rem;
  font-weight: 800;
}

.partnerrow button {
  background-color: #000;
  color: #fff;
  border: none;
}

.virtical-line {
  width: 1px;
  height: 160px;
  background: #868686;
}

.darkcontentbox {
  background-color: #000;
  color: white;
  font-weight: 600;
  padding: 3rem;
  font-size: 1.1rem;
}

.image-container {
  width: 20%;
}

.sliderbtn {
  cursor: pointer;
  margin: 0 0 -3rem 0;
  z-index: 44;
}

.sliderbtn button {
  border: none;
  background-color: transparent;
  color: #fff;
}

.sliderbtn button:focus {
  outline: none;
}
.slick-track {
  display: flex !important;
}

.slick-slide {
  height: inherit !important;
}
.slick-slide div {
  height: 100%;
}
.cartcontainer {
  cursor: pointer;
  justify-content: end;
  position: absolute;
  width: 100%;
  display: flex;
  margin: 0rem 3rem 0rem 0rem;
}

.testimonialslider {
  display: flex;
  overflow: hidden;
  overflow-x: auto;
  justify-content: start;
  /* width: 100%; */
  scrollbar-width: none;
}

.testimonialslider::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.testimonialslider img {
  /* Ensure images maintain aspect ratio */
  height: 100%; /* Fill the height of the container */
  width: auto; /* Let the width adjust automatically */
}

.testimonialslider .slider {
  display: flex;
  justify-content: center;
}

.sliderimage {
  height: auto;
  display: flex;
}
.show {
  display: block;
}

.collapse {
  display: none;
}

.showmorebtn {
  background: black;
  color: white;
  border: none;
  border-radius: 0.3rem;
  padding: 0.5rem;
  cursor: pointer;
  text-transform: uppercase;
  margin-top: 2rem;
}

.showmorebtn:focus {
  outline: none;
}

.sticky3 {
  position: sticky;
  top: 160px;
  font-size: 13px;
  padding: 10px;
  z-index: 99;
}

.cursorPointer {
  cursor: pointer;
}

.Section_accordionContent__MfSla {
  overflow: hidden;
  max-height: 1000px;
  transition: max-height 1s ease-in-out;
}

.summary {
  -webkit-line-clamp: 4;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.dropdownarrow {
  transition: transform 0.5s ease 0s;
  transform: rotate(0deg);
}

.dropdownarrow2 {
  transition: transform 0.5s ease 0s;
  transform: rotate(180deg);
}

.progress-container {
  width: 100%;
  background-color: #f0f0f0;
}

/* Style the progress bar */
.progress-bar {
  width: 0%;
  height: 4px;
  /* Change the height of the progress bar */
  background-color: rgb(255, 233, 114);
  z-index: 144;
  position: fixed;
}

@media screen and (max-width: 992.5px) {
  .navbar {
    margin-left: 0;
  }

  .successcontainer {
    padding-left: 2.25rem;
    padding-right: 0.313rem;
  }

  .successbanner {
    margin-top: 7rem;
  }

  .servicecards {
    position: relative;
    height: 19rem;
    width: 19rem;
  }

  .contentbody {
    width: 20rem;
    height: 10rem;
    font-size: 10px;
  }

  .blognav {
    justify-content: space-between;
  }

  .blognav label {
    background-color: #000;
    font-size: 1.2rem;
    font-weight: 600;
    color: #fff;
  }

  .blognav li {
    width: 100%;
    text-align: center;
    margin: 0;
  }

  .service img {
    margin-top: 7rem;
    height: 7rem;
  }

  .image-container {
    width: 50%;
  }
}

@media screen and (max-width: 768.5px) {
  .navbar {
    margin-left: 0;
  }

  .successcontainer {
    padding-left: 2.25rem;
    padding-right: 0.313rem;
  }

  .successbanner {
    margin-top: 7rem;
  }

  .brandcontainer .image {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .brandcontainer .image img {
    max-height: 65px;
    margin: auto;
    width: 100%;
  }

  .service img {
    margin-top: 7rem;
    height: 7rem;
  }

  .servicecards {
    height: 19rem;
    width: 19rem;
  }

  .contentbody {
    width: 20rem;
    height: 10rem;
    font-size: 10px;
  }

  .blognav {
    font-size: 0.875rem;
    min-width: 0rem;
  }

  .blognav label {
    background-color: #000;
    font-size: 1.2rem;
    font-weight: 600;
    color: #fff;
  }

  .blognav li {
    width: 100%;
    text-align: center;
    margin: 0;
  }

  .titlefont {
    font-size: 40px;
  }

  .aboutcontainer {
    padding: 0;
  }

  .home_heading_img {
    width: 98%;
  }

  .home_heading_body {
    width: 98%;
  }

  .banner {
    height: 46vh;
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 7rem;
  }
}

@media only screen and (max-width: 480.5px) {
  html {
    font-size: 80%;
  }

  .contectdetails {
    padding: 0rem 0px 5rem 0rem;
  }

  .navbar {
    margin-left: 0;
    height: 3.938rem;
  }

  .alanlabel {
    font-size: 1.5rem;
    margin: 0;
  }

  .aboutcontainer {
    padding: 0;
  }

  .home_heading_img {
    width: 98%;
  }

  .home_heading_body {
    width: 98%;
  }

  .imglogo {
    height: 8rem;
    aspect-ratio: 7 / 5;
    object-fit: contain;
  }

  .banner {
    height: 19rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 28%;
    margin-top: 3rem;
  }

  .whatsappcontainer img {
    width: 3.2rem;
    height: 3.2rem;
  }

  .whatsappcontainer label {
    border-radius: 0.5rem;
    margin: 3.438rem 1.125rem auto auto;
    width: 8rem;
    font-size: 0.9rem;
  }

  .whatsappcontainer span {
    margin: 2.5rem 0rem 0rem -1.5rem;
  }

  .aboutalan {
    width: 100%;
  }

  .alanlabel span {
    font-family: Open Sans Condensed, sans-serif;
  }

  .successbanner {
    height: 32rem;
    margin-top: 3rem;
    background-position: 68%;
    border-bottom: none;
  }

  .successcontainer {
    padding-left: 0;
    padding-right: 0;
  }

  .contentimg {
    width: 60%;
  }

  .cards .cardimage {
    width: 100%;
    height: 12rem;
  }

  .cards .cardimage img {
    width: 100%;
    height: 125px;
  }

  .cards {
    position: absolute;
    background-color: #fff;
    width: 60%;
  }

  .cards .cardbody {
    width: 100%;
    height: 9rem;
    padding: 0rem 1rem 0rem 1rem;
  }

  .cards .cardbody label {
    font-size: 12px;
    line-height: 1.2rem;
  }

  .cards .cardbody p {
    font-size: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    color: #777;
    line-height: 1.35em;
  }

  .sliderbtn {
    margin: 0 0 7rem 0;
  }

  .slide0 {
    transform: translate3d(-60%, 0, -200px);
  }

  .slide1 {
    transform: translate3d(-30%, 0, -100px);
  }

  .slide2 {
    transform: translateZ(0);
  }

  .slide3 {
    transform: translate3d(30%, 0, -100px);
  }

  .slide4 {
    transform: translate3d(60%, 0, -200px);
  }

  .contactcontainer {
    background-color: transparent;
    width: 22rem;
  }

  .checkoutlebel {
    font-size: 2rem;
  }

  .brandcontainer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brandcontainer .image {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .brandcontainer .image img {
    max-height: 65px;
    margin: auto;
    width: 100%;
  }

  .service img {
    margin-top: 3rem;
    height: 7rem;
  }

  .blognav {
    font-size: 0.875rem;
    min-width: 24rem;
  }

  .blognav ul {
    width: 100%;
  }

  .blognav li {
    width: 100%;
    text-align: center;
    margin: 0;
    padding: 1rem !important;
  }

  .titlefont {
    font-size: 20px;
  }

  .titlefont2 {
    font-size: 22px;
    /* margin-left: 10px; */
  }

  .blogcontainer {
    margin: 6rem 0% 0 0%;
    width: 100%;
  }

  .blogcontainer2 {
    margin: 1rem 0% 0 0%;
    width: 100%;
  }

  .servicecontainer {
    margin-left: 5%;
    margin-right: 5%;
  }

  .servicecards {
    width: 28rem;
    height: 28rem;
  }

  .contentbody {
    width: 29rem;
    height: 10rem;
    font-size: 12px;
  }

  .portfolio {
    margin-top: -6rem;
  }

  .image-container {
    width: 100%;
  }

  .contactcontainer {
    background-color: transparent;
    width: 100%;
  }

  .titlefont3 {
    font-size: 20px;
    margin-top: 80px;
  }

  .sidebar {
    max-width: 100%;
  }

  .social {
    top: 14rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sliderimage {
    height: auto;
    display: flex;
  }

  .titlefont4 {
    font-size: 1.2rem;
  }

  .sticky3 {
    box-shadow: 0 10px 12px 0 rgba(0, 0, 0, 0.15);
    background-color: #fff;
  }

  .sticky2 {
    position: fixed;
    background: #fff;
    width: 100%;
    top: 0;
    z-index: 122;
    min-height: 4rem;
  }
}

@media only screen and (max-width: 375.5px) {
  .banner {
    height: 16rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 23%;
    margin-top: 12%;
  }
  .plan,
  .plan-white {
    width: 100%;
  }
  .service img {
    margin-top: 3.5rem;
    height: 5rem;
  }

  .successbanner {
    height: 36rem;
    margin-top: 3.5rem;
    background-position: 75%;
  }

  .sidebar {
    max-width: 100%;
  }

  .aboutcontainer {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    padding: 0;
  }

  .home_heading_img {
    width: 98%;
  }

  .home_heading_body {
    width: 98%;
  }

  .servicecontainer {
    margin-left: 5%;
    margin-right: 5%;
  }

  .servicecards {
    width: 23rem;
    height: 23rem;
  }

  .contentbody {
    width: 24rem;
    height: 11rem;
    font-size: 10px;
  }

  .sliderimage {
    height: auto;
    display: flex;
  }
}

/* Animation */

.slide-in-left {
  animation: slide-in-left 2s ease-in-out;
}

.slide-in-right {
  animation: slide-in-right 2s ease-in-out;
}

.slide-in-bottom {
  animation: slide-in-bottom 2s ease-in-out;
}

.slide-in-top {
  animation: slide-in-top 2s ease-in-out;
}

@keyframes slide-in-left {
  from {
    transform: translateX(-10%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes slide-in-right {
  from {
    transform: translateX(10%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes slide-in-bottom {
  from {
    transform: translateY(30%);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes slide-in-top {
  from {
    transform: translateY(-30%);
  }

  to {
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/index.css"],"names":[],"mappings":"AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;AACA;;;GAGG;;AAEH;EACE,0CAA0C;AAC5C;;AAEA;EACE;;;;;;GAMC;AACH;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,+CAA+C;EAC/C,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,cAAc,EAAE,iCAAiC;AACnD;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yDAA6C;EAC7C,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yDAA2D;EAC3D,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;EACf,YAAY;EACZ,UAAU;EACV,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;;EAEb,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,6DAA6D;EAC7D;iEAC+D;AACjE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,yBAAyB,EAAE,0CAA0C;AACvE;;AAEA;EACE,yBAAyB,EAAE,gDAAgD;AAC7E;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EAEX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB;uBACqB;EACrB;oBACkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;EAC5B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,YAAY,EAAE,qCAAqC;EACnD,WAAW,EAAE,uCAAuC;AACtD;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,SAAS;EACT,WAAW;EACX,0CAA0C;EAC1C,oCAAoC;EACpC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,mCAAmC;IACnC,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6CAA6C;IAC7C,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,MAAM;IACN,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,wBAAwB;IACxB,eAAe;EACjB;EACA;;IAEE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,cAAc;;AAEd;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Exo:wght@800&family=Montserrat:wght@300&family=Open+Sans+Condensed:wght@700&family=Roboto+Slab:wght@700&display=swap\");\n\nhtml {\n  font-size: 100%;\n}\n\nbody {\n  margin: 0;\n  /* font-family: Open Sans Condensed, sans-serif; */\n  /* -webkit-font-smoothing: antialiased; */\n  /* -moz-osx-font-smoothing: grayscale; */\n}\n\n.font_11 {\n  font-size: 0.688rem;\n}\n\n.font_12 {\n  font-size: 0.75rem;\n}\n\n.font_13 {\n  font-size: 0.813rem;\n}\n\n.font_14 {\n  font-size: 0.875rem;\n}\n\n.font_15 {\n  font-size: 0.938rem;\n}\n\n.font_16 {\n  font-size: 14px;\n}\n.font_17 {\n  font-size: 16px;\n}\n\n.font_18 {\n  font-size: 1.125rem;\n}\n\n.font_19 {\n  font-size: 1.188rem;\n}\n\n.font_20 {\n  font-size: 1.25rem;\n}\n\n.font_22 {\n  font-size: 1.375rem;\n}\n\n.font_24 {\n  font-size: 1.5rem;\n}\n\n.font_26 {\n  font-size: 1.625rem;\n}\n\n.font_28 {\n  font-size: 1.75rem;\n}\n\n.font_30 {\n  font-size: 1.875rem;\n}\n\n.font_32 {\n  font-size: 2rem;\n}\n\n.font_34 {\n  font-size: 2.125rem;\n}\n\n.font_36 {\n  font-size: 2.25rem;\n}\n\n.font_38 {\n  font-size: 2.375rem;\n}\n\n.font_40 {\n  font-size: 2.5rem;\n}\n\n.font_42 {\n  font-size: 2.625rem;\n}\n\n.font_44 {\n  font-size: 2.75rem;\n}\n\n.font_46 {\n  font-size: 2.875rem;\n}\n\n.font_48 {\n  font-size: 3rem;\n}\n\n.font_50 {\n  font-size: 3.125rem;\n}\n\n.font_52 {\n  font-size: 3.25rem;\n}\n\n.font_54 {\n  font-size: 3.375rem;\n}\n\n.font_600 {\n  font-weight: 600;\n}\n\n.font_700 {\n  font-weight: 700;\n}\n\n.font_r {\n  color: red;\n}\n\n.font_y {\n  color: #ffe972;\n}\n\n.font_blk {\n  color: #000;\n}\n\n.font_w {\n  color: #fff;\n}\n\n.font_gry {\n  color: gray;\n}\n\n.font_mgnt {\n  color: #8b008b;\n}\n\n.font_bl {\n  color: #003153;\n}\n\n.letter_15 {\n  letter-spacing: 0.15em;\n}\n\n.alanlabel {\n  font-size: 3.25rem;\n  font-weight: 600;\n  flex: 1 1;\n  text-align: center;\n  cursor: pointer;\n  letter-spacing: 0.15em;\n  font-family: Open Sans Condensed, sans-serif;\n  margin: -1rem 0 0.1rem 7rem;\n}\n\n.alanlabel:hover {\n  color: #ffe972;\n}\n\n.border-top {\n  border-top: 0.375rem solid #ffe972;\n}\n\n.universalbackground {\n  background: linear-gradient(#3e205a, #212020);\n}\n/* \n.universalbackground4 {\n  background: linear-gradient(c281e3,);\n} */\n\n.universalbackground2 {\n  background: linear-gradient(#3e205a, #000);\n}\n\n.universalbackground3 {\n  background: linear-gradient(\n    #3e205a 6.25rem,\n    #324a80 75rem,\n    #000 131.25rem,\n    #3e205a 187.5rem,\n    #000 243.75rem\n  );\n}\n\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  color: #fff;\n  background: #000;\n  z-index: 111;\n}\n\n.nav1 {\n  height: 6.25rem;\n  display: flex;\n  padding: 0.5em 1em;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.navcontainer {\n  padding: 0 0em 1rem;\n  display: flex;\n  justify-content: space-evenly;\n  font-weight: 700;\n  position: relative;\n  max-width: 87.5rem;\n  margin: 0 auto;\n  width: 100%;\n  margin-left: 3rem;\n  cursor: pointer;\n  z-index: 44;\n}\n\n.navcontainer div:hover {\n  color: #ffe972;\n}\n\n.navbar li {\n  cursor: pointer;\n  font-size: 1.063rem;\n  font-weight: 700;\n}\n\n.navbar li:hover {\n  color: #ffe972;\n}\n\n.consultbtn {\n  background-color: #ffe972;\n  color: #000;\n  padding: 0.313rem 1.25rem;\n  box-shadow: -0.625rem 0.625rem 5.625rem #ffe972;\n  border: none;\n  height: 2.5rem;\n}\n\n.btn {\n  border: none;\n  cursor: pointer;\n}\n\n#btn {\n  /* animation: btn 0.5s ease-in infinite; */\n  animation: btn 0.6s linear infinite;\n}\n.blogContents ul li::marker {\n  color: #ffe972; /* Change to your desired color */\n}\n\n@keyframes btn {\n  25% {\n    transform: scale(0.9);\n  }\n\n  75% {\n    transform: scale(1.1);\n  }\n}\n\n.btn2 {\n  padding: 0.313rem 1.25rem;\n  color: #ffe972;\n  border: none;\n  cursor: pointer;\n}\n\n#btn2 {\n  animation: btn2 0.5s ease-in infinite;\n}\n\n@keyframes btn2 {\n  25% {\n    transform: scale(0.9);\n  }\n\n  75% {\n    transform: scale(1.1);\n  }\n}\n\n.footerbody {\n  background-color: #000;\n  color: white;\n}\n\n.footerbody hr {\n  border-bottom: 0.063rem solid #ffe972;\n  max-width: 12.5rem;\n  margin: 0.813rem auto;\n  width: 100%;\n}\n\n.footerbody a {\n  color: white;\n  cursor: pointer;\n  margin: 0px 0.5rem 0px 0.5rem;\n}\n\nfooter img {\n  width: 100%;\n}\n\n.banner {\n  background-image: url(./../images/banner.png);\n  background-size: cover;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  background-position: no-repeat;\n  background-position: 50%;\n  margin-top: 9rem;\n}\n\n.successbanner {\n  background-image: url(./../images/cover_image.a08b3550.jpg);\n  background-size: cover;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  background-position: no-repeat;\n  background-position: 50%;\n  margin-top: 9rem;\n  border-bottom: 6px solid rgb(255, 233, 114);\n}\n\n.whatsappcontainer {\n  position: fixed;\n  bottom: 0;\n  right: 1.875rem;\n  z-index: 999;\n  padding: 0;\n  font-size: 5rem;\n  cursor: pointer;\n  display: flex;\n}\n\n.whatsappcontainer img {\n  width: 4.2rem;\n  height: 4.2rem;\n}\n\n.whatsappcontainer label {\n  background-color: gray;\n  font-weight: 700;\n  padding: 0.375rem 1.563rem;\n  border-radius: 0.5rem;\n  margin: 3.438rem 1.125rem auto auto;\n  width: 9rem;\n  position: relative;\n  font-size: 1rem;\n  color: white;\n}\n\n.whatsappcontainer span {\n  background-color: red;\n  border-radius: 50%;\n  width: 1rem;\n  height: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 0.875rem;\n  padding: 0.5rem;\n  margin: 2rem 0rem 0rem -1.5rem;\n}\n\n.contactcontainer {\n  background-color: transparent;\n  width: 37rem;\n}\n\n.text-content {\n  border: 0.063rem solid #fff;\n  margin: 0.375rem 0;\n  background: transparent;\n  color: #717171;\n  resize: none;\n}\n\n.country_codes {\n  position: absolute;\n  background-color: #fff;\n  width: 21rem;\n  height: 16rem;\n\n  padding: 0.3rem;\n  margin: 18rem 0rem 0 17.5rem;\n}\n\n.recommedation {\n  width: 20rem;\n  height: 16rem;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.aboutalan {\n  padding: 0.625rem 2.5rem 2.5rem;\n  background: rgba(0, 0, 0, 0.5);\n  margin-top: 6.25rem;\n  border: 0.125rem solid #000;\n  width: 70%;\n}\n\n.aboutalan .AlanProfileContent {\n  position: relative;\n}\n\n.aboutalan .AlanProfileContent img {\n  border-radius: 50%;\n  border: 0.125rem solid #ffe972;\n  width: 80%;\n}\n\n.sliderdiv {\n  width: 100%;\n  padding: 1rem;\n  padding-top: 1.25rem;\n  position: relative;\n  perspective: 62.5rem;\n  transform-style: preserve-3d;\n}\n\n.cards {\n  margin: auto;\n  width: 37%;\n  border-radius: 16px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  cursor: pointer;\n  transition: transform 0.4s ease;\n  background-color: #fff;\n  --tw-shadow: 0 14px 40px -10px rgba(0, 0, 0, 0.35) !important;\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),\n    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\n}\n\n.cards .cardimage {\n  height: 215px;\n}\n\n.cards .cardimage img {\n  width: 100%;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n}\n\n.cards .cardbody {\n  height: 250px;\n  padding: 40px 32px 20px;\n}\n\n.cards .cardbody label {\n  line-height: 1.7rem;\n}\n\n.cards .cardbody p {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  color: #777;\n  line-height: 1.35em;\n}\n\n.slide0 {\n  transform: translate3d(-60%, 0, -200px);\n}\n\n.slide1 {\n  transform: translate3d(-30%, 0, -100px);\n}\n\n.slide2 {\n  transform: translateZ(0);\n}\n\n.slide3 {\n  transform: translate3d(30%, 0, -100px);\n}\n\n.slide4 {\n  transform: translate3d(60%, 0, -200px);\n}\n\n.sidebar {\n  position: fixed;\n  max-width: 23.75rem;\n  width: 100%;\n  height: 100vh;\n  background-color: #111;\n  margin: 0;\n  top: 0;\n  color: white;\n  font-size: 0.875rem;\n  transition: 0.5s;\n  z-index: 222;\n  overflow: auto;\n  overflow-x: hidden;\n}\n\n.sidebar .search {\n  border-radius: 2rem;\n  width: 88%;\n  height: 2.5rem;\n  margin-bottom: 2rem;\n  /* display: flex; */\n  /* justify-content: center; */\n  /* align-items: center; */\n}\n\n.sidebar .search input {\n  width: 16rem;\n  height: 3rem;\n  background-color: transparent;\n  border: none;\n}\n\n.sidebar .search input:focus {\n  outline: none;\n}\n\n.suggestions {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.suggestions li {\n  padding: 0.5rem;\n  cursor: pointer;\n  z-index: 999;\n  background-color: #deddd7; /* Adjust the background color as needed */\n}\n\n.suggestions li:hover {\n  background-color: #282954; /* Adjust the hover background color as needed */\n}\n.suggestion-box {\n  margin: 97% 15% 0 0;\n  height: auto;\n  width: auto;\n}\n\n.sidebar a {\n  color: white;\n  margin: 0.5rem;\n}\n\n.sidebar li {\n  cursor: pointer;\n  font-family: \"Exo 2\", sans-serif;\n  font-size: 12px;\n}\n\n.blognav {\n  background-color: #000;\n  color: #fff;\n  font-size: 0.875rem;\n  min-width: 70rem;\n}\n\n.blognav label {\n  background-color: #ffe972;\n  color: #000;\n  padding: 1rem;\n  margin: 0;\n}\n\n.blognav li {\n  list-style: none;\n  margin: 0 auto;\n  padding: 0rem 1rem 0 1rem;\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.service img {\n  margin-top: 9rem;\n  width: 100vw;\n  height: 14rem;\n}\n\n.servicecards {\n  position: relative;\n  height: 22rem;\n  width: 22rem;\n}\n\n.servicecards img {\n  height: 100%;\n  width: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n  position: absolute;\n  opacity: 1;\n  transform: scale(1);\n  transition: all 0.8s, opacity 0.4s;\n}\n\n.social {\n  position: sticky;\n  top: 14rem;\n}\n\n.socialicons {\n  background-color: #000;\n  border-radius: 50%;\n  width: 4rem;\n  height: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@keyframes servicecards {\n  from {\n    transform: scale(1.1);\n  }\n\n  to {\n    transform: scale(1);\n  }\n}\n\n.contentbody {\n  background: hsla(0, 0%, 100%, 0.8);\n  width: 22rem;\n  height: 12rem;\n  transition: all 0.5s;\n  position: absolute;\n  margin: auto;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  box-sizing: border-box;\n  padding: 0rem 0.5rem 0 0.5rem;\n}\n\n.contentbody label {\n  background: linear-gradient(270deg, #433074 0, #a364a2);\n  color: #fff;\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  display: block;\n  border-radius: 1.875rem;\n  padding: 0.75rem 1.563rem 0.625rem;\n  transition: all 0.5s ease;\n  cursor: pointer;\n  margin-bottom: 0.625rem;\n}\n\n.blogbanner {\n  color: #fff;\n  position: relative;\n}\n\n.blogbanner img {\n  width: 100%;\n}\n\n.cover {\n  color: #fff;\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  /* position: relative; */\n  /* align-items: center; */\n  /* display: flex; */\n  /* justify-content: center; */\n  position: absolute;\n  top: 0;\n}\n\n.cover button {\n  background-color: #000;\n  color: white;\n  cursor: pointer;\n  font-weight: 600;\n  width: 10rem;\n  height: 3.5rem;\n  border-radius: 0.375rem;\n  font-size: larger;\n  margin-top: 5%;\n  border: none;\n}\n\n.blogcards img {\n  width: 100%;\n}\n\n.home_heading_img {\n  width: 62.5rem;\n}\n\n.home_heading_body {\n  width: 43.75rem;\n}\n\n.line {\n  border-top: 0.063rem solid #003153;\n  margin-top: 4rem;\n  margin-bottom: 2rem;\n}\n\n.imglogo {\n  height: 10rem;\n  aspect-ratio: 7 / 5;\n  object-fit: contain;\n}\n\n.bottomUpbtn {\n  position: absolute;\n  right: 0px;\n  margin: 0 5rem 9rem 0rem;\n  font-size: 2.5rem;\n  color: #ffe972;\n  animation: bottomUpbtn 2s ease-in-out;\n}\n\n@keyframes bottomUpbtn {\n  from {\n    transform: translateY(100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n.successcontainer {\n  padding-left: 6.25rem;\n  padding-right: 0.313rem;\n}\n\n.contentimg {\n  width: 100%;\n}\n\n.blogcontainer {\n  margin: 10rem 5% 0 5%;\n  width: 90%;\n}\n\n.blogcontainer2 {\n  margin: 1rem 2% 0 2%;\n  width: 100%;\n}\n\n.blognavbar {\n  background-color: #000;\n  color: white;\n}\n\n.blognavbar label {\n  background-color: #ffe972;\n  color: #000;\n  padding: 1rem;\n  margin: 0;\n}\n\n.blognavbar li {\n  list-style: none;\n  margin: 0 auto;\n  padding: 0rem 1rem 0 1rem;\n  cursor: pointer;\n}\n\n.acitive {\n  color: #ffe972;\n  font-weight: 700;\n}\n\n.servicecontainer {\n  /* margin:3rem 5rem 0 5rem; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* flex-wrap: wrap; */\n  /* padding-right: 4%;\n    padding-left: 4%; */\n  /* margin-right: 8%;\n  margin-left: 8%; */\n  width: 100%;\n}\n\n.servicecontainer h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  font-family: Roboto Slab, serif;\n}\n\n.servicecontainer hr {\n  border-bottom: 3px solid #ffe972;\n  max-width: 200px;\n  margin: 20px auto 2.5rem;\n}\n\n.hrline {\n  border-bottom: 2px solid #ffe972;\n}\n\n.plan {\n  background-color: #000;\n  color: #fff;\n  text-align: center;\n  font-family: Roboto Slab, serif;\n  padding: 4rem 0rem 3rem 0rem;\n}\n\n.plan li {\n  list-style: none;\n  border-bottom: 1px solid rgba(9, 9, 9, 0.04);\n  font-size: 12px;\n  font-weight: 400;\n  padding: 10px 15px;\n}\n\n.plan .month {\n  font-size: 22px;\n  height: 82px;\n  padding: 0 8px;\n  font-weight: 600;\n  color: #ffe972;\n}\n\n.plan button {\n  color: #000 !important;\n  background-color: #ffe972 !important;\n  border: none;\n  border-radius: 0;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);\n  font-family: Roboto Slab, Sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  margin: 15px 0 10px;\n  padding: 12px 25px;\n}\n\n.plan-white {\n  background-color: #fff;\n  color: #000;\n  text-align: center;\n  font-family: Roboto Slab, serif;\n  padding: 4rem 0rem 3rem 0rem;\n  width: 376px;\n}\n\n.plan-white li {\n  list-style: none;\n  border-bottom: 1px solid rgba(9, 9, 9, 0.04);\n  font-size: 12px;\n  font-weight: 400;\n  padding: 10px 15px;\n}\n\n.plan-white .month {\n  height: 82px;\n  padding: 0 8px;\n  font-weight: 600;\n  color: #ffe972;\n}\n\n.plan-white button {\n  color: #fff !important;\n  background-color: #000 !important;\n  border: none;\n  border-radius: 0;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);\n  font-family: Roboto Slab, Sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  margin: 15px 0 10px;\n  padding: 12px 25px;\n}\n\n/* popups */\n\n.headermodel {\n  border-bottom: 1px solid #dee2e6;\n  width: 100%;\n  padding: 1rem;\n  justify-content: space-between;\n}\n\n.headermodel button {\n  background-color: #000;\n  color: #fff;\n}\n\n.Layout_inputData {\n  height: 30px;\n  width: 100%;\n  position: relative;\n}\n\n.Layout_inputData input {\n  height: 100%;\n  width: 100%;\n  font-size: 13px;\n  border: none;\n  border-bottom: 2px solid #eee;\n}\n\n.Layout_inputData input:focus {\n  outline: none;\n}\n\n.Layout_inputData .Layout_underline {\n  position: absolute;\n  height: 2px;\n  width: 100%;\n  bottom: 0;\n}\n\n.Layout_inputData .Layout_underline::before {\n  position: absolute;\n  content: \"\";\n  height: 100%;\n  width: 100%;\n  background: #000;\n  transform: scaleX(0);\n  transform-origin: center;\n  transition: transform 0.3s ease;\n}\n\n.Layout_inputData input:focus ~ label,\n.Layout_inputData input:valid ~ label {\n  transform: translateY(-20px);\n  font-size: 13px;\n  color: #000;\n}\n\n.Layout_inputData label {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  color: #000;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  margin-bottom: 9px;\n}\n\n.copon {\n  border: 1px solid #eee;\n}\n\n.couponbtn {\n  background-color: #000;\n  color: #fff;\n  border-radius: 0.5rem;\n  border: none;\n}\n\n.couponbtn:hover {\n  background-color: white;\n  color: black;\n  border-radius: 0.5rem;\n  border: 1px solid black;\n}\n\n.paybtn {\n  background-color: #ffe972;\n  cursor: pointer;\n  border: none;\n}\n\n.footermodel {\n  border-bottom: 1px solid #dee2e6;\n  width: 100%;\n  padding: 1rem;\n  justify-content: space-between;\n}\n\n.footermodel button {\n  background-color: #000;\n  color: #fff;\n  border-radius: 0.5rem;\n  border: none;\n}\n\n.contectdetails {\n  padding: 12rem 0px 5rem 0rem;\n}\n\n.brandcontainer .image {\n  height: 105px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.brandcontainer .image img {\n  max-height: 85px;\n  margin: auto;\n  width: 100%;\n}\n\n.collapsbtn {\n  border: none;\n}\n\n.collapsbtn:focus {\n  border: none;\n  outline: none;\n}\n\n.icon {\n  transform: rotate(0deg);\n  transition: 0.3s ease-in-out;\n}\n\n.icon:hover {\n  transform: rotate(180deg);\n  transition: 0.3s ease-in-out;\n}\n\n.titlefont {\n  font-size: 52px;\n}\n\n.titlefont2 {\n  font-size: 30px;\n}\n\n.titlefont3 {\n  font-size: 32px;\n}\n\n.titlefont4 {\n  font-size: 2.5rem;\n}\n\n.titlefamily {\n  font-family: Roboto Slab, serif;\n}\n\n.portfolio {\n  width: 98%;\n}\n\n.phonenumber input {\n  border: none;\n  color: #717171;\n}\n\n.phonenumber input:focus {\n  outline: none;\n}\n\n.autherimage img {\n  width: 28%;\n}\n\n.authorimagebox img {\n  border-radius: 50%;\n  max-width: 15rem;\n  height: 15rem;\n}\n\n.aboutcontainer {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.partnerrow {\n  background-color: #eee;\n}\n\n.partnerrow img {\n  width: 60%;\n  position: relative;\n}\n\n.partnerrow .nametext {\n  font-size: 1.8rem;\n  font-weight: 800;\n}\n\n.partnerrow button {\n  background-color: #000;\n  color: #fff;\n  border: none;\n}\n\n.virtical-line {\n  width: 1px;\n  height: 160px;\n  background: #868686;\n}\n\n.darkcontentbox {\n  background-color: #000;\n  color: white;\n  font-weight: 600;\n  padding: 3rem;\n  font-size: 1.1rem;\n}\n\n.image-container {\n  width: 20%;\n}\n\n.sliderbtn {\n  cursor: pointer;\n  margin: 0 0 -3rem 0;\n  z-index: 44;\n}\n\n.sliderbtn button {\n  border: none;\n  background-color: transparent;\n  color: #fff;\n}\n\n.sliderbtn button:focus {\n  outline: none;\n}\n.slick-track {\n  display: flex !important;\n}\n\n.slick-slide {\n  height: inherit !important;\n}\n.slick-slide div {\n  height: 100%;\n}\n.cartcontainer {\n  cursor: pointer;\n  justify-content: end;\n  position: absolute;\n  width: 100%;\n  display: flex;\n  margin: 0rem 3rem 0rem 0rem;\n}\n\n.testimonialslider {\n  display: flex;\n  overflow: hidden;\n  overflow-x: auto;\n  justify-content: start;\n  /* width: 100%; */\n  scrollbar-width: none;\n}\n\n.testimonialslider::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.testimonialslider img {\n  /* Ensure images maintain aspect ratio */\n  height: 100%; /* Fill the height of the container */\n  width: auto; /* Let the width adjust automatically */\n}\n\n.testimonialslider .slider {\n  display: flex;\n  justify-content: center;\n}\n\n.sliderimage {\n  height: auto;\n  display: flex;\n}\n.show {\n  display: block;\n}\n\n.collapse {\n  display: none;\n}\n\n.showmorebtn {\n  background: black;\n  color: white;\n  border: none;\n  border-radius: 0.3rem;\n  padding: 0.5rem;\n  cursor: pointer;\n  text-transform: uppercase;\n  margin-top: 2rem;\n}\n\n.showmorebtn:focus {\n  outline: none;\n}\n\n.sticky3 {\n  position: sticky;\n  top: 160px;\n  font-size: 13px;\n  padding: 10px;\n  z-index: 99;\n}\n\n.cursorPointer {\n  cursor: pointer;\n}\n\n.Section_accordionContent__MfSla {\n  overflow: hidden;\n  max-height: 1000px;\n  transition: max-height 1s ease-in-out;\n}\n\n.summary {\n  -webkit-line-clamp: 4;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n.dropdownarrow {\n  transition: transform 0.5s ease 0s;\n  transform: rotate(0deg);\n}\n\n.dropdownarrow2 {\n  transition: transform 0.5s ease 0s;\n  transform: rotate(180deg);\n}\n\n.progress-container {\n  width: 100%;\n  background-color: #f0f0f0;\n}\n\n/* Style the progress bar */\n.progress-bar {\n  width: 0%;\n  height: 4px;\n  /* Change the height of the progress bar */\n  background-color: rgb(255, 233, 114);\n  z-index: 144;\n  position: fixed;\n}\n\n@media screen and (max-width: 992.5px) {\n  .navbar {\n    margin-left: 0;\n  }\n\n  .successcontainer {\n    padding-left: 2.25rem;\n    padding-right: 0.313rem;\n  }\n\n  .successbanner {\n    margin-top: 7rem;\n  }\n\n  .servicecards {\n    position: relative;\n    height: 19rem;\n    width: 19rem;\n  }\n\n  .contentbody {\n    width: 20rem;\n    height: 10rem;\n    font-size: 10px;\n  }\n\n  .blognav {\n    justify-content: space-between;\n  }\n\n  .blognav label {\n    background-color: #000;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #fff;\n  }\n\n  .blognav li {\n    width: 100%;\n    text-align: center;\n    margin: 0;\n  }\n\n  .service img {\n    margin-top: 7rem;\n    height: 7rem;\n  }\n\n  .image-container {\n    width: 50%;\n  }\n}\n\n@media screen and (max-width: 768.5px) {\n  .navbar {\n    margin-left: 0;\n  }\n\n  .successcontainer {\n    padding-left: 2.25rem;\n    padding-right: 0.313rem;\n  }\n\n  .successbanner {\n    margin-top: 7rem;\n  }\n\n  .brandcontainer .image {\n    height: 80px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .brandcontainer .image img {\n    max-height: 65px;\n    margin: auto;\n    width: 100%;\n  }\n\n  .service img {\n    margin-top: 7rem;\n    height: 7rem;\n  }\n\n  .servicecards {\n    height: 19rem;\n    width: 19rem;\n  }\n\n  .contentbody {\n    width: 20rem;\n    height: 10rem;\n    font-size: 10px;\n  }\n\n  .blognav {\n    font-size: 0.875rem;\n    min-width: 0rem;\n  }\n\n  .blognav label {\n    background-color: #000;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #fff;\n  }\n\n  .blognav li {\n    width: 100%;\n    text-align: center;\n    margin: 0;\n  }\n\n  .titlefont {\n    font-size: 40px;\n  }\n\n  .aboutcontainer {\n    padding: 0;\n  }\n\n  .home_heading_img {\n    width: 98%;\n  }\n\n  .home_heading_body {\n    width: 98%;\n  }\n\n  .banner {\n    height: 46vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n    margin-top: 7rem;\n  }\n}\n\n@media only screen and (max-width: 480.5px) {\n  html {\n    font-size: 80%;\n  }\n\n  .contectdetails {\n    padding: 0rem 0px 5rem 0rem;\n  }\n\n  .navbar {\n    margin-left: 0;\n    height: 3.938rem;\n  }\n\n  .alanlabel {\n    font-size: 1.5rem;\n    margin: 0;\n  }\n\n  .aboutcontainer {\n    padding: 0;\n  }\n\n  .home_heading_img {\n    width: 98%;\n  }\n\n  .home_heading_body {\n    width: 98%;\n  }\n\n  .imglogo {\n    height: 8rem;\n    aspect-ratio: 7 / 5;\n    object-fit: contain;\n  }\n\n  .banner {\n    height: 19rem;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: 28%;\n    margin-top: 3rem;\n  }\n\n  .whatsappcontainer img {\n    width: 3.2rem;\n    height: 3.2rem;\n  }\n\n  .whatsappcontainer label {\n    border-radius: 0.5rem;\n    margin: 3.438rem 1.125rem auto auto;\n    width: 8rem;\n    font-size: 0.9rem;\n  }\n\n  .whatsappcontainer span {\n    margin: 2.5rem 0rem 0rem -1.5rem;\n  }\n\n  .aboutalan {\n    width: 100%;\n  }\n\n  .alanlabel span {\n    font-family: Open Sans Condensed, sans-serif;\n  }\n\n  .successbanner {\n    height: 32rem;\n    margin-top: 3rem;\n    background-position: 68%;\n    border-bottom: none;\n  }\n\n  .successcontainer {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .contentimg {\n    width: 60%;\n  }\n\n  .cards .cardimage {\n    width: 100%;\n    height: 12rem;\n  }\n\n  .cards .cardimage img {\n    width: 100%;\n    height: 125px;\n  }\n\n  .cards {\n    position: absolute;\n    background-color: #fff;\n    width: 60%;\n  }\n\n  .cards .cardbody {\n    width: 100%;\n    height: 9rem;\n    padding: 0rem 1rem 0rem 1rem;\n  }\n\n  .cards .cardbody label {\n    font-size: 12px;\n    line-height: 1.2rem;\n  }\n\n  .cards .cardbody p {\n    font-size: 11px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    color: #777;\n    line-height: 1.35em;\n  }\n\n  .sliderbtn {\n    margin: 0 0 7rem 0;\n  }\n\n  .slide0 {\n    transform: translate3d(-60%, 0, -200px);\n  }\n\n  .slide1 {\n    transform: translate3d(-30%, 0, -100px);\n  }\n\n  .slide2 {\n    transform: translateZ(0);\n  }\n\n  .slide3 {\n    transform: translate3d(30%, 0, -100px);\n  }\n\n  .slide4 {\n    transform: translate3d(60%, 0, -200px);\n  }\n\n  .contactcontainer {\n    background-color: transparent;\n    width: 22rem;\n  }\n\n  .checkoutlebel {\n    font-size: 2rem;\n  }\n\n  .brandcontainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .brandcontainer .image {\n    height: 80px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .brandcontainer .image img {\n    max-height: 65px;\n    margin: auto;\n    width: 100%;\n  }\n\n  .service img {\n    margin-top: 3rem;\n    height: 7rem;\n  }\n\n  .blognav {\n    font-size: 0.875rem;\n    min-width: 24rem;\n  }\n\n  .blognav ul {\n    width: 100%;\n  }\n\n  .blognav li {\n    width: 100%;\n    text-align: center;\n    margin: 0;\n    padding: 1rem !important;\n  }\n\n  .titlefont {\n    font-size: 20px;\n  }\n\n  .titlefont2 {\n    font-size: 22px;\n    /* margin-left: 10px; */\n  }\n\n  .blogcontainer {\n    margin: 6rem 0% 0 0%;\n    width: 100%;\n  }\n\n  .blogcontainer2 {\n    margin: 1rem 0% 0 0%;\n    width: 100%;\n  }\n\n  .servicecontainer {\n    margin-left: 5%;\n    margin-right: 5%;\n  }\n\n  .servicecards {\n    width: 28rem;\n    height: 28rem;\n  }\n\n  .contentbody {\n    width: 29rem;\n    height: 10rem;\n    font-size: 12px;\n  }\n\n  .portfolio {\n    margin-top: -6rem;\n  }\n\n  .image-container {\n    width: 100%;\n  }\n\n  .contactcontainer {\n    background-color: transparent;\n    width: 100%;\n  }\n\n  .titlefont3 {\n    font-size: 20px;\n    margin-top: 80px;\n  }\n\n  .sidebar {\n    max-width: 100%;\n  }\n\n  .social {\n    top: 14rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .sliderimage {\n    height: auto;\n    display: flex;\n  }\n\n  .titlefont4 {\n    font-size: 1.2rem;\n  }\n\n  .sticky3 {\n    box-shadow: 0 10px 12px 0 rgba(0, 0, 0, 0.15);\n    background-color: #fff;\n  }\n\n  .sticky2 {\n    position: fixed;\n    background: #fff;\n    width: 100%;\n    top: 0;\n    z-index: 122;\n    min-height: 4rem;\n  }\n}\n\n@media only screen and (max-width: 375.5px) {\n  .banner {\n    height: 16rem;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: 23%;\n    margin-top: 12%;\n  }\n  .plan,\n  .plan-white {\n    width: 100%;\n  }\n  .service img {\n    margin-top: 3.5rem;\n    height: 5rem;\n  }\n\n  .successbanner {\n    height: 36rem;\n    margin-top: 3.5rem;\n    background-position: 75%;\n  }\n\n  .sidebar {\n    max-width: 100%;\n  }\n\n  .aboutcontainer {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n    padding: 0;\n  }\n\n  .home_heading_img {\n    width: 98%;\n  }\n\n  .home_heading_body {\n    width: 98%;\n  }\n\n  .servicecontainer {\n    margin-left: 5%;\n    margin-right: 5%;\n  }\n\n  .servicecards {\n    width: 23rem;\n    height: 23rem;\n  }\n\n  .contentbody {\n    width: 24rem;\n    height: 11rem;\n    font-size: 10px;\n  }\n\n  .sliderimage {\n    height: auto;\n    display: flex;\n  }\n}\n\n/* Animation */\n\n.slide-in-left {\n  animation: slide-in-left 2s ease-in-out;\n}\n\n.slide-in-right {\n  animation: slide-in-right 2s ease-in-out;\n}\n\n.slide-in-bottom {\n  animation: slide-in-bottom 2s ease-in-out;\n}\n\n.slide-in-top {\n  animation: slide-in-top 2s ease-in-out;\n}\n\n@keyframes slide-in-left {\n  from {\n    transform: translateX(-10%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes slide-in-right {\n  from {\n    transform: translateX(10%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes slide-in-bottom {\n  from {\n    transform: translateY(30%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes slide-in-top {\n  from {\n    transform: translateY(-30%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
